import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  HashRouter,
} from "react-router-dom";

import MainView from "../MainView";
import SpanishView from "../SpanishView";
import EnglishView from "../EnglishView";

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rutas */}

        <Route path="/" element={<MainView />} />
        <Route path="/cv-espanol" element={<SpanishView />} />
        <Route path="/cv-english" element={<EnglishView />} />

      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
